import React, { useState, useEffect } from 'react';
import { Modal, Typography, Button, CircularButton } from '@hpstellar/core';
import { Cross } from '@hpstellar/icons';

import GameCard from './game-card';
import { pickFPS } from './util';

import './game-fps-modal.less';

export default function GameFPSModal({
    gameList,
    gameTitles,
    graphicsPreset,
    selecting,
    selection,
    onSelection,
    onModalClose,
}) {
    const [disable, setDisable] = useState(false);
    const [selectedGames, setSelectedGames] = useState(selection);
    const [tempSelectedGames, setTempSelectedGames] = useState(selection);

    useEffect(() => {
        setSelectedGames(selection);
        setTempSelectedGames(selection);
        setDisable(selection.length > 4);
    }, [selection]);

    const gameSelected = game => {
        const selected = selectedGames.some(s => s.id === game.id);

        let newSelectedGames;
        if (selected) {
            newSelectedGames = selectedGames.filter(s => s.id !== game.id);
        } else {
            newSelectedGames = [...selectedGames, game];
        }
        setSelectedGames(newSelectedGames);
        setDisable(newSelectedGames.length > 4);
    };

    const clear = () => {
        setSelectedGames([]);
        setDisable(false);
    };

    const onCalculate = () => {
        onSelection(selectedGames);
        onModalClose();
    };

    const onClose = () => {
        setSelectedGames(tempSelectedGames);
        setDisable(tempSelectedGames.length > 4);
        onModalClose();
    };

    return (
        <Modal
            className="gameFPSModal"
            isOpen={selecting}
            animationType="fade-in"
            aria-describedby="modal-description"
            aria-labelledby="modal-title"
            horizontalAlignment="center"
            verticalAlignment="center"
            withBackdrop
        >
            <div className="modalContent">
                <div className="modalHeader">
                    <Typography className="title" variant="titleM">
                        Select up to 5 Games
                    </Typography>
                    <CircularButton icon="cross" size="small" onClick={onClose} />
                </div>
                <div className="gameGrid">
                    {gameList.map((game, index) => {
                        const selected = selectedGames.some(s => s.id === game.id);
                        return (
                            <GameCard
                                {...game}
                                fps={pickFPS(game, gameTitles, graphicsPreset)}
                                selected={selected}
                                key={index}
                                disable={disable && !selected}
                                onToggle={() => gameSelected({ ...game, id: index })}
                            />
                        );
                    })}
                </div>

                <div className="modalFooter">
                    {selectedGames.length > 0 && (
                        <Button
                            size="small"
                            color="dark"
                            variation="secondary"
                            onClick={clear}
                            endIcon={<Cross size="xs" />}
                        >
                            CLEAR ALL
                        </Button>
                    )}
                    <Button
                        size="small"
                        variation="primary"
                        color="dark"
                        onClick={onCalculate}
                        disabled={selectedGames.length < 1}
                    >
                        CALCULATE FPS
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
